import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import { onResendMessage } from '../handler/ChatPostHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogSendChatPostFail = props => {
    useTranslationSubscription();

    const onHandlerCancel = () => {
        props.setIsOpenDialogSendChatPostFail(false);
        let chatPostAllListNew = cloneDeep(props.chatPostAllList);
        chatPostAllListNew = chatPostAllListNew.slice(0, -1);;
        props.setChatPostAllList({
            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
            posts: chatPostAllListNew ? chatPostAllListNew : [],
        });
    };

    const onHandlerResendMessage = async () => {
        let chatPostInsertFail = props.chatPostInsertFail;
        let dataResend = chatPostInsertFail.data;
        delete dataResend.userDetailPostMsg;
        let inputChatPost = {
            createNewChatPostRequestDto : dataResend
        }
        props.setIsOpenDialogSendChatPostFail(false);
        await onResendMessage(props?.API, inputChatPost, props.userDetail, props.setChatPostUpdate, props.setChatPostInsertFail);
    };

    return (
        <Dialog
            open={props.isOpenDialogSendChatPostFail}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{trI18n('COMMSG002')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={onHandlerResendMessage}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN006')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onHandlerCancel}
                >
                    {trI18n('COMBTN005')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
